import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateTimeComponent } from "../../templates/template-time/template-time.component";

@Component({
  selector: "app-prefix-tid",
  imports: [TemplateTimeComponent],
  templateUrl: "./prefix-tid.component.html",
  styleUrl: "./prefix-tid.component.less",
})
export class PrefixTidComponent extends PrefixComponent<string> {
  public constructor() {
    super();
    this.characters = ALLOWED_CHARACTERS["tid"];
  }
}
